"use strict";

module.exports = function (column) {

    if (this.opts.dateFormatPerColumn.hasOwnProperty(column)) {
        return this.opts.dateFormatPerColumn[column];
    }

    return this.opts.dateFormat;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/date-format.js
// module id = 2163
// module chunks = 2